var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSideIconAnalytics = function SvgSideIconAnalytics(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    y: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 9,
    x: 12,
    y: 3,
    rx: 1
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSideIconAnalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/side-icon-Analytics.570bc3013d473dabdde104a80d512877.svg";